// ============================================================================
// API — Publicación (panel-super-admin).
// ============================================================================

import { supabaseClient } from '@plataforma/supabase-client';

/**
 * Llama a la Edge Function publicar_tienda.
 */
export async function publicarTienda(empresaId) {
  const { data, error } = await supabaseClient().functions.invoke('publicar_tienda', {
    body: { empresa_id: empresaId },
  });

  if (error) {
    return { data: null, error };
  }

  return { data, error: null };
}

/**
 * Llama a la Edge Function actualizar_disponibilidad_tienda.
 */
export async function actualizarDisponibilidad(empresaId) {
  const { data, error } = await supabaseClient().functions.invoke(
    'actualizar_disponibilidad_tienda',
    {
      body: { empresa_id: empresaId },
    },
  );

  if (error) {
    return { data: null, error };
  }

  return { data, error: null };
}
